import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const CoberturaReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Obtener datos PSS
   */
  builder
    .addCase(Types.OBTENER_DATOS_PSS_LOADING, (state) => {
      state.obtenerDatosPssLoading = true;
      state.obtenerDatosPssError = null;
    })
    .addCase(Types.OBTENER_DATOS_PSS_SUCCESS, (state, action) => {
      const { obtenerDatosPssData } = action;
      state.obtenerDatosPssData = obtenerDatosPssData;
      state.obtenerDatosPssLoading = false;
      state.obtenerDatosPssError = null;
    })
    .addCase(Types.OBTENER_DATOS_PSS_FAILURE, (state, action) => {
      const { obtenerDatosPssError } = action;
      state.obtenerDatosPssData = INITIAL_STATE.datosPssData;
      state.obtenerDatosPssLoading = false;
      state.obtenerDatosPssError = obtenerDatosPssError;
    });

  /**
   * Obtener coberturas contratadas PSS
   */
  builder
    .addCase(Types.OBTENER_COBERTURA_CONTRATADA_PSS_LOADING, (state) => {
      state.obtenerCoberturaContratadaPssLoading = true;
      state.obtenerCoberturaContratadaPssError = null;
    })
    .addCase(
      Types.OBTENER_COBERTURA_CONTRATADA_PSS_SUCCESS,
      (state, action) => {
        const { obtenerCoberturaContratadaPssData } = action;
        state.obtenerCoberturaContratadaPssData = {
          coberturas: obtenerCoberturaContratadaPssData?.coberturas || [],
          totalRegistros: obtenerCoberturaContratadaPssData?.totalRegistros || 0,
          numeroPagina: obtenerCoberturaContratadaPssData?.numeroPagina || 1,
          tamanoPagina: obtenerCoberturaContratadaPssData?.tamanoPagina || 20,
          totalPaginas: obtenerCoberturaContratadaPssData?.totalPaginas || 1
        };
        state.obtenerCoberturaContratadaPssLoading = false;
        state.obtenerCoberturaContratadaPssError = null;
      }
    )
    .addCase(
      Types.OBTENER_COBERTURA_CONTRATADA_PSS_FAILURE,
      (state, action) => {
        const { obtenerCoberturaContratadaPssError } = action;
        state.obtenerCoberturaContratadaPssData =
          INITIAL_STATE.obtenerCoberturaContratadaPssData;
        state.obtenerCoberturaContratadaPssLoading = false;
        state.obtenerCoberturaContratadaPssError =
          obtenerCoberturaContratadaPssError;
      }
    );

  /**
   * guardar coberturas contratadas PSS
   */
  builder
    .addCase(Types.GUARDAR_COBERTURA_CONTRATADA_PSS_LOADING, (state) => {
      state.guardarCoberturaContratadaPssLoading = true;
      state.guardarCoberturaContratadaPssError = null;
    })
    .addCase(
      Types.GUARDAR_COBERTURA_CONTRATADA_PSS_SUCCESS,
      (state, action) => {
        const { guardarCoberturaContratadaPssData } = action;
        state.guardarCoberturaContratadaPssData =
          guardarCoberturaContratadaPssData;
        state.guardarCoberturaContratadaPssLoading = false;
        state.guardarCoberturaContratadaPssError = null;
      }
    )
    .addCase(
      Types.GUARDAR_COBERTURA_CONTRATADA_PSS_FAILURE,
      (state, action) => {
        const { guardarCoberturaContratadaPssError } = action;
        state.guardarCoberturaContratadaPssData =
          INITIAL_STATE.guardarCoberturaContratadaPssData;
        state.guardarCoberturaContratadaPssLoading = false;
        state.guardarCoberturaContratadaPssError =
          guardarCoberturaContratadaPssError;
      }
    );

  /**
   * Obtener tipos coberturas
   */
  builder
    .addCase(Types.OBTENER_TIPO_COBERTURAS_LOADING, (state) => {
      state.obtenerTipoCoberturasLoading = true;
      state.obtenerTipoCoberturasError = null;
    })
    .addCase(Types.OBTENER_TIPO_COBERTURAS_SUCCESS, (state, action) => {
      const { obtenerTipoCoberturasData } = action;
      state.obtenerTipoCoberturasData = obtenerTipoCoberturasData;
      state.obtenerTipoCoberturasLoading = false;
      state.obtenerTipoCoberturasError = null;
    })
    .addCase(Types.OBTENER_TIPO_COBERTURAS_FAILURE, (state, action) => {
      const { obtenerTipoCoberturasError } = action;
      state.obtenerTipoCoberturasData = INITIAL_STATE.obtenerTipoCoberturasData;
      state.obtenerTipoCoberturasLoading = false;
      state.obtenerTipoCoberturasError = obtenerTipoCoberturasError;
    });

  /**
   * Obtener coberturas
   */
  builder
    .addCase(Types.OBTENER_COBERTURAS_LOADING, (state) => {
      state.obtenerCoberturasLoading = true;
      state.obtenerCoberturasError = null;
    })
    .addCase(Types.OBTENER_COBERTURAS_SUCCESS, (state, action) => {
      const { obtenerCoberturasData } = action;
      state.obtenerCoberturasData = obtenerCoberturasData;
      state.obtenerCoberturasLoading = false;
      state.obtenerCoberturasError = null;
    })
    .addCase(Types.OBTENER_COBERTURAS_FAILURE, (state, action) => {
      const { obtenerCoberturasError } = action;
      state.obtenerCoberturasData = INITIAL_STATE.obtenerCoberturasData;
      state.obtenerCoberturasLoading = false;
      state.obtenerCoberturasError = obtenerCoberturasError;
    });

  /**
   * Obtener cobertura documentos
   */
  builder
    .addCase(Types.OBTENER_COBERTURA_DOCUMENTOS_LOADING, (state) => {
      state.obtenerCoberturaDocumentosLoading = true;
      state.obtenerCoberturaDocumentosError = null;
    })
    .addCase(Types.OBTENER_COBERTURA_DOCUMENTOS_SUCCESS, (state, action) => {
      const { obtenerCoberturaDocumentosData } = action;
      state.obtenerCoberturaDocumentosData = obtenerCoberturaDocumentosData;
      state.obtenerCoberturaDocumentosLoading = false;
      state.obtenerCoberturaDocumentosError = null;
    })
    .addCase(Types.OBTENER_COBERTURA_DOCUMENTOS_FAILURE, (state, action) => {
      const { obtenerCoberturaDocumentosError } = action;
      state.obtenerCoberturaDocumentosData =
        INITIAL_STATE.obtenerCoberturaDocumentosData;
      state.obtenerCoberturaDocumentosLoading = false;
      state.obtenerCoberturaDocumentosError = obtenerCoberturaDocumentosError;
    });

  /**
   * Guardar cobertura documentos
   */
  builder
    .addCase(Types.GUARDAR_COBERTURA_DOCUMENTOS_LOADING, (state) => {
      state.guardarCoberturaDocumentosLoading = true;
      state.guardarCoberturaDocumentosError = null;
    })
    .addCase(Types.GUARDAR_COBERTURA_DOCUMENTOS_SUCCESS, (state, action) => {
      const { guardarCoberturaDocumentosData } = action;
      state.guardarCoberturaDocumentosData = guardarCoberturaDocumentosData;
      state.guardarCoberturaDocumentosLoading = false;
      state.guardarCoberturaDocumentosError = null;
    })
    .addCase(Types.GUARDAR_COBERTURA_DOCUMENTOS_FAILURE, (state, action) => {
      const { guardarCoberturaDocumentosError } = action;
      state.guardarCoberturaDocumentosData =
        INITIAL_STATE.guardarCoberturaDocumentosData;
      state.guardarCoberturaDocumentosLoading = false;
      state.guardarCoberturaDocumentosError = guardarCoberturaDocumentosError;
    });

  /**
   * Obtener coberturas configuradas PSS
   */
  builder
    .addCase(Types.OBTENER_COBERTURAS_CONFIGURADAS_PSS_LOADING, (state) => {
      state.obtenerCoberturasConfiguradasPssLoading = true;
      state.obtenerCoberturasConfiguradasPssError = null;
    })
    .addCase(
      Types.OBTENER_COBERTURAS_CONFIGURADAS_PSS_SUCCESS,
      (state, action) => {
        const { obtenerCoberturasConfiguradasPssData } = action;
        state.obtenerCoberturasConfiguradasPssData =
          obtenerCoberturasConfiguradasPssData;
        state.obtenerCoberturasConfiguradasPssLoading = false;
        state.obtenerCoberturasConfiguradasPssError = null;
      }
    )
    .addCase(
      Types.OBTENER_COBERTURAS_CONFIGURADAS_PSS_FAILURE,
      (state, action) => {
        const { obtenerCoberturasConfiguradasPssError } = action;
        state.obtenerCoberturasConfiguradasPssData =
          INITIAL_STATE.obtenerCoberturasConfiguradasPssData;
        state.obtenerCoberturasConfiguradasPssLoading = false;
        state.obtenerCoberturasConfiguradasPssError =
          obtenerCoberturasConfiguradasPssError;
      }
    );

  /**
   * Obtener documentos coberturas configuradas
   */
  builder
    .addCase(
      Types.OBTENER_COBERTURAS_CONFIGURADAS_DOCUMENTOS_LOADING,
      (state) => {
        state.obtenerCoberturasConfiguradasDocumentosLoading = true;
        state.obtenerCoberturasConfiguradasDocumentosError = null;
      }
    )
    .addCase(
      Types.OBTENER_COBERTURAS_CONFIGURADAS_DOCUMENTOS_SUCCESS,
      (state, action) => {
        const { obtenerCoberturasConfiguradasDocumentosData } = action;
        state.obtenerCoberturasConfiguradasDocumentosData =
          obtenerCoberturasConfiguradasDocumentosData;
        state.obtenerCoberturasConfiguradasDocumentosLoading = false;
        state.obtenerCoberturasConfiguradasDocumentosError = null;
      }
    )
    .addCase(
      Types.OBTENER_COBERTURAS_CONFIGURADAS_DOCUMENTOS_FAILURE,
      (state, action) => {
        const { obtenerCoberturasConfiguradasDocumentosError } = action;
        state.obtenerCoberturasConfiguradasDocumentosData =
          INITIAL_STATE.obtenerCoberturasConfiguradasDocumentosData;
        state.obtenerCoberturasConfiguradasDocumentosLoading = false;
        state.obtenerCoberturasConfiguradasDocumentosError =
          obtenerCoberturasConfiguradasDocumentosError;
      }
    );
});
